export default "__VITE_ASSET__ogo4x0VX__"